/**
 * Utility functions for MCC (Merchant Category Code) related operations
 */

/** Normalize MCC from API (may be number or string). */
const toMccNumber = (mccId: number | string | undefined): number | undefined =>
  mccId == null ? undefined : Number(mccId);

/**
 * Checks if a merchant has MCC ID 1 (0420 - Cannabis/Dispensary/Marijuana)
 * @param mccId - The MCC ID to check (number or string from API)
 * @returns true if the merchant has MCC ID 1, false otherwise
 */
export const is0420Merchant = (mccId: number | string | undefined): boolean => {
  return toMccNumber(mccId) === 1;
};

/**
 * Checks if a merchant has MCC ID 1736 (5122 - Peptide Products)
 * @param mccId - The MCC ID to check (number or string from API)
 * @returns true if the merchant has MCC ID 1736, false otherwise
 */
export const isPeptidesMerchant = (mccId: number | string | undefined): boolean => {
  return toMccNumber(mccId) === 1736;
};
